"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "block pb-2 font-bold uppercase tracking-wide text-sm"
};
const _hoisted_2 = { class: "flex justify-center items-center" };
const _hoisted_3 = ["id", "value"];
const _hoisted_4 = ["for"];
const _hoisted_5 = {
    key: 1,
    class: "text-red mt-2 text-sm"
};
const vue_3 = require("vue");
const randomString_1 = __importDefault(require("../../../common/utils/randomString"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'RadioGroupInput',
    props: {
        label: {
            type: String,
            required: false,
            default: "",
        },
        options: {
            type: Array,
            required: true,
            default: () => []
        },
        modelValue: [Number, String, () => null],
        showValidity: {
            type: Boolean,
            default: false,
        },
        valid: {
            type: Boolean,
            default: true,
            required: false
        },
        invalidMessage: {
            type: String,
            required: false,
            default: ''
        },
        showInput: {
            type: Boolean,
            default: true
        },
        selectedClass: {
            type: String,
            required: false
        }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit }) {
        const props = __props;
        const selectedRadioOption = (0, vue_3.ref)(null);
        (0, vue_3.watch)(selectedRadioOption, () => {
            emit('update:modelValue', selectedRadioOption.value);
        });
        const id = (0, randomString_1.default)(12);
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (__props.label !== '')
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_1, (0, vue_2.toDisplayString)(__props.label), 1))
                    : (0, vue_2.createCommentVNode)("", true),
                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.options, (option, index) => {
                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                        key: option.value,
                        class: "flex"
                    }, [
                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", _hoisted_2, [
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                type: "radio",
                                id: `radioGroup-${(0, vue_2.unref)(id)}-${index}`,
                                value: option.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedRadioOption).value = $event)),
                                class: "mr-2"
                            }, null, 8, _hoisted_3), [
                                [vue_2.vModelRadio, selectedRadioOption.value]
                            ])
                        ], 512), [
                            [vue_2.vShow, __props.showInput]
                        ]),
                        (0, vue_2.createElementVNode)("label", {
                            for: `radioGroup-${(0, vue_2.unref)(id)}-${index}`,
                            class: (0, vue_2.normalizeClass)(["grow font-bold inline-block cursor-pointer", {
                                    'text-red': !__props.valid && __props.showValidity,
                                    [String(__props.selectedClass)]: option.value === __props.modelValue
                                }])
                        }, [
                            (0, vue_2.renderSlot)(_ctx.$slots, "option", { option: option })
                        ], 10, _hoisted_4)
                    ]));
                }), 128)),
                (__props.showValidity && __props.invalidMessage !== '' && !__props.valid)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, (0, vue_2.toDisplayString)(__props.invalidMessage), 1))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 64));
        };
    }
});
